import React, { Component } from "react";
import ApexCharts from 'apexcharts'

class NewBreachReportGraph extends Component {
	constructor(props){
		super(props);
	}
	state = { chart: null }

	componentDidMount = () => {
		this.load();
	}
	componentDidUpdate = (prevProps) => {
		if(this.props.dataArray !== prevProps.dataArray){
			if(this.state.chart) this.state.chart.destroy();
			this.load();
		}
	}

	load = () => {
		let {dataArray, chartId} = this.props;
		let data = dataArray.map(item => item.value);
		let categories = dataArray.map(item => item.label);
		if(!data || data.length == 0){
			data = [0];
			categories = ['No Data'];
		}
		let options = {
			series: [{
			//   name: "Sales",
			//   group: 'budget',
			  data,
			}],
			chart: {
			  height: 350,
			  type: 'bar',
			  zoom: {
				enabled: true
			  },
			  toolbar: {
				show: false
			  }
			},
			colors: ['#50b7e0', '#628fe2', '#6c64e3', '#b051e3', '#d74ee1'],
			plotOptions: {
			  bar: {
				horizontal: false,
				columnWidth: '30%',
				dataLabels: {
				  position: 'top',
				},
				distributed: true,
			  }
			},
			dataLabels: {
			  enabled: true,
			  formatter: (val) => val + "%",
			},
			stroke: {
			  curve: 'smooth',
			},
			xaxis: {
			  type: 'category',
			  categories
			},
			yaxis: {
                min: 0,
                max: 100,
				tickAmount: 5,
            },
			tooltip: {
			  show: false,
			},
			grid: {
			  show: true,
			},
			legend: {
				show: false,
			},
		
		  };
		  
		  
		var chart = new ApexCharts(document.querySelector(`#${chartId}`), options);
		chart.render();
		this.setState({chart: chart})
	}

	render() {
		return (
			<div id={this.props.chartId}></div>
		);
	}
}

function areEqual(prevProps, nextProps) {
  // Only re-render if dataArray reference or content changes
  if (prevProps.dataArray === nextProps.dataArray) return true;
  if (!prevProps.dataArray || !nextProps.dataArray) return false;
  if (prevProps.dataArray.length !== nextProps.dataArray.length) return false;
  for (let i = 0; i < prevProps.dataArray.length; i++) {
    if (
      prevProps.dataArray[i].label !== nextProps.dataArray[i].label ||
      prevProps.dataArray[i].value !== nextProps.dataArray[i].value
    ) {
      return false;
    }
  }
  return true;
}
export default React.memo(NewBreachReportGraph, areEqual);